import { useState, Suspense } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import Sidenav, { initialCollapsed } from "./Sidenav.jsx";
import UsageLock from "./UsageLock.jsx";
import { Spinner } from "./primitives.jsx";
import { useAuth } from "../context/AuthContext.jsx";

/* The authenticated app shell: fixed sidenav + routed page content. Mirrors the
 * gating shell.js did on mount — bounce to /login when unauthenticated, force a
 * must_change user to /account, and overlay the usage lock when capped. */
export default function Shell() {
  const { me, loading, locked } = useAuth();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(initialCollapsed());
  const [drawerOpen, setDrawerOpen] = useState(false);

  if (loading) {
    return (
      <div className="page">
        <div className="empty">Loading…</div>
      </div>
    );
  }

  if (!me) return <Navigate to="/login" replace state={{ from: location }} />;

  // One-time password: force the reset before anything else is reachable.
  if (me.must_change && location.pathname !== "/account") {
    return <Navigate to="/account" replace />;
  }

  return (
    <div className={"app-shell" + (collapsed ? " nav-collapsed" : "")}>
      <Sidenav
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        drawerOpen={drawerOpen}
        setDrawerOpen={setDrawerOpen}
      />
      <Suspense fallback={<Spinner />}>
        <Outlet />
      </Suspense>
      {locked && <UsageLock resetEpoch={locked.resetEpoch} />}
    </div>
  );
}
